export default __webpack_public_path__ + "img/component-profile-card.998d74d0.png";